import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private storage: StorageService,
  ) { }

  public async loadInitialTheme() {
    let themeActive = await this.storage.get('themeActive');
    if (themeActive) {
      this.document.body.classList.add('theme-alternate');
    } else {
      this.document.body.classList.remove('theme-alternate');
    }
  }

  public async toggleTheme() {
    if (this.themeActive) {
      this.document.body.classList.remove('theme-alternate');
      await this.storage.set('themeActive', false);
    } else {
      this.document.body.classList.add('theme-alternate');
      await this.storage.set('themeActive', true);
    }
  }

  public get themeActive(): boolean {
    return this.document.body.classList.contains('theme-alternate');
  }
}
